import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import styles from "./style.module.css";

import { Navigation, Autoplay } from "swiper/modules";
import { Box, IconButton, Typography } from "@mui/material";
import { SliderArrowLeft, SliderArrowRight } from "../../assets/icons/MUI/LoginIcons";
import SirAlex from "../../assets/images/Login/SirAlex.png";
import Pele from "../../assets/images/Login/Pele.png";
import Beckenbauer from "../../assets/images/Login/Beckenbauer.png";
import { useTranslation } from "react-i18next";

const QuotesSlider = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
        maxWidth: { xs: "100%", sm: "500px", lg: "650px" },
        margin: "0 auto",
        padding: { xs: "20px", sm: "30px", lg: "0" },
      }}
    >
      <Swiper
        loop={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        modules={[Navigation, Autoplay]}
        className={styles.mySwiper}
      >
        <SwiperSlide>
          <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: "20px", sm: "22px", lg: "25px" } }}>
            <Box
              component="figure"
              sx={{
                display: "flex",
                columnGap: { xs: "15px", sm: "18px", lg: "20px" },
                alignItems: "center",
                justifyContent: "flex-start",
                margin: "0",
              }}
            >
              <img
                src={SirAlex}
                width="51px"
                height="51px"
                style={{ width: "auto", height: "auto", maxWidth: "51px", maxHeight: "51px" }}
              />
              <Typography
                component="figcaption"
                sx={{
                  color: "var(--White, #FFF)",
                  fontFamily: "Montserrat",
                  fontSize: { xs: "28px", sm: "34px", lg: "40px" },
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: { xs: "32px", sm: "38px", lg: "45px" },
                  letterSpacing: "-0.8px",
                }}
              >
                {t("pages.login.sirAlex")}
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "var(--White, #FFF)",
                fontFamily: "Montserrat",
                fontSize: { xs: "20px", sm: "25px", lg: "30px" },
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: { xs: "28px", sm: "35px", lg: "45px" },
                letterSpacing: "-0.6px",
              }}
            >
              "{t("pages.login.sirAlexQuote")}"
            </Typography>
          </Box>
        </SwiperSlide>
        <SwiperSlide>
          <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: "20px", sm: "22px", lg: "25px" } }}>
            <Box
              component="figure"
              sx={{
                display: "flex",
                columnGap: { xs: "15px", sm: "18px", lg: "20px" },
                alignItems: "center",
                justifyContent: "flex-start",
                margin: "0",
              }}
            >
              <img
                src={Beckenbauer}
                width="51px"
                height="51px"
                style={{ width: "auto", height: "auto", maxWidth: "51px", maxHeight: "51px" }}
              />
              <Typography
                component="figcaption"
                sx={{
                  color: "var(--White, #FFF)",
                  fontFamily: "Montserrat",
                  fontSize: { xs: "28px", sm: "34px", lg: "40px" },
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: { xs: "32px", sm: "38px", lg: "45px" },
                  letterSpacing: "-0.8px",
                }}
              >
                {t("pages.login.beckenbauer")}
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "var(--White, #FFF)",
                fontFamily: "Montserrat",
                fontSize: { xs: "20px", sm: "25px", lg: "30px" },
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: { xs: "28px", sm: "35px", lg: "45px" },
                letterSpacing: "-0.6px",
              }}
            >
              "{t("pages.login.beckenbauerQoute")}"
            </Typography>
          </Box>
        </SwiperSlide>
        <SwiperSlide>
          <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: "20px", sm: "22px", lg: "25px" } }}>
            <Box
              component="figure"
              sx={{
                display: "flex",
                columnGap: { xs: "15px", sm: "18px", lg: "20px" },
                alignItems: "center",
                justifyContent: "flex-start",
                margin: "0",
              }}
            >
              <img
                src={Pele}
                width="51px"
                height="51px"
                style={{ width: "auto", height: "auto", maxWidth: "51px", maxHeight: "51px" }}
              />
              <Typography
                component="figcaption"
                sx={{
                  color: "var(--White, #FFF)",
                  fontFamily: "Montserrat",
                  fontSize: { xs: "28px", sm: "34px", lg: "40px" },
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: { xs: "32px", sm: "38px", lg: "45px" },
                  letterSpacing: "-0.8px",
                }}
              >
                {t("pages.login.pele")}
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "var(--White, #FFF)",
                fontFamily: "Montserrat",
                fontSize: { xs: "20px", sm: "25px", lg: "30px" },
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: { xs: "28px", sm: "35px", lg: "45px" },
                letterSpacing: "-0.6px",
              }}
            >
              "{t("pages.login.peleQuote")}"
            </Typography>
          </Box>
        </SwiperSlide>
        <SliderNavigation />
      </Swiper>
    </Box>
  );
};

export default QuotesSlider;

const SliderNavigation = () => {
  const swiper = useSwiper();
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  return (
    <Box
      sx={{
        display: "flex",
        columnGap: { xs: "20px", sm: "28px", lg: "32px" },
        marginTop: { xs: "40px", sm: "80px", lg: "167px" },
        justifyContent: "center",
      }}
    >
      <IconButton
        onClick={() => swiper.slidePrev()}
        sx={{
          border: "1px solid rgba(255, 255, 255, 0.50)",
          backdropFilter: " blur(4px)",
          width: { xs: "40px", sm: "44px", lg: "48px" },
          height: { xs: "40px", sm: "44px", lg: "48px" },
        }}
      >
        {currentLang === "en" ? <SliderArrowLeft /> : <SliderArrowRight />}
      </IconButton>
      <IconButton
        onClick={() => swiper.slideNext()}
        sx={{
          border: "1px solid rgba(255, 255, 255, 0.50)",
          backdropFilter: " blur(4px)",
          width: { xs: "40px", sm: "44px", lg: "48px" },
          height: { xs: "40px", sm: "44px", lg: "48px" },
        }}
      >
        {currentLang === "en" ? <SliderArrowRight /> : <SliderArrowLeft />}
      </IconButton>
    </Box>
  );
};

// const SlideQuote = ({ img, name, description }: { img: string; name: string; description: string }) => (
//   <SwiperSlide>
//     <Box sx={{ display: "flex", flexDirection: "column", gap: "25px" }}>
//       <Box
//         component="figure"
//         sx={{
//           display: "flex",
//           columnGap: "20px",
//           alignItems: "center",
//           justifyContent: "flex-start",
//           margin: "0",
//         }}
//       >
//         <img src={img} width="51px" height="51px" />
//         <Typography
//           component="figcaption"
//           sx={{
//             color: "var(--White, #FFF)",
//             fontFamily: "Montserrat",
//             fontSize: "40px",
//             fontStyle: "normal",
//             fontWeight: 600,
//             lineHeight: "45px",
//             letterSpacing: "-0.8px",
//           }}
//         >
//           {name}
//         </Typography>
//       </Box>
//       <Typography
//         sx={{
//           color: "var(--White, #FFF)",
//           fontFamily: "Montserrat",
//           fontSize: "30px",
//           fontStyle: "normal",
//           fontWeight: 500,
//           lineHeight: "45px",
//           letterSpacing: "-0.6px",
//         }}
//       >
//         “{description}”
//       </Typography>
//     </Box>
//   </SwiperSlide>
// );
